export function parsePrimitivesFromString(value: string | unknown) {
  if ([true, false, '', null, undefined].includes(value as any) || Array.isArray(value) || typeof value === 'object') {
    return value;
  }

  if (Number.isNaN(Number(value))) {
    switch (value) {
      case 'true': {
        return true;
      }

      case 'false': {
        return false;
      }

      case 'null': {
        return null;
      }

      case 'undefined': {
        return undefined;
      }

      default: {
        return value;
      }
    }
  } else {
    return Number(value);
  }
}
